import { cn } from '@/lib/utils'

type AuthAction = 'sign-in' | 'sign-up' | string

type Props = {
  action: AuthAction
  className?: string
}

const LINK_CLASSES =
  'text-brand underline-offset-2 hover:underline rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand'

/**
 * Consentimento legal das telas de autenticação.
 *
 * São **dois** documentos distintos, e por isso dois links: termos de uso e
 * política de privacidade. Antes era um link só, rotulado "Termos de uso e
 * políticas da EVNTTZ" — quem quisesse ler a política de privacidade não tinha
 * como chegar até ela.
 *
 * O "e" entre os dois fica na cor do texto corrido, não na dos links: pintá-lo
 * de roxo sugeriria que ele também leva a algum lugar.
 *
 * Aparece apenas em entrar e cadastrar — nas telas de recuperação o
 * consentimento já ocorreu.
 */
export const TermsUseAndPolicies = ({ action, className }: Props) => {
  if (action !== 'sign-in' && action !== 'sign-up') return null

  return (
    <p
      className={cn(
        'm-0 max-w-xs text-center text-xs font-semibold leading-snug text-gray-700',
        className
      )}
    >
      Ao {action === 'sign-in' ? 'entrar' : 'cadastrar-se'}, você concorda com
      nossos
      <br />
      <a
        href="https://www.evnttz.com.br/termos-de-uso"
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASSES}
      >
        Termos de uso
      </a>{' '}
      e{' '}
      <a
        href="https://www.evnttz.com.br/politica-de-privacidade"
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASSES}
      >
        Política de privacidade
      </a>
    </p>
  )
}
